import { actions } from './patient_transaction/actions'
import { getters } from './patient_transaction/getters'
import { state } from './patient_transaction/state'
import { mutations } from './patient_transaction/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
